var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11853_7643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11853_7643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.70724 20.4016C5.4524 20.4016 5.23749 20.3158 5.06249 20.1443C4.88749 19.9728 4.79999 19.7603 4.79999 19.5068C4.79999 19.2533 4.88615 19.0391 5.05849 18.8641C5.23099 18.6891 5.44465 18.6016 5.69949 18.6016H18.2927C18.5476 18.6016 18.7625 18.6873 18.9375 18.8588C19.1125 19.0303 19.2 19.2428 19.2 19.4963C19.2 19.7498 19.1138 19.9641 18.9415 20.1391C18.769 20.3141 18.5553 20.4016 18.3005 20.4016H5.70724ZM11.995 16.4266C11.875 16.4266 11.7625 16.4057 11.6575 16.3641C11.5525 16.3224 11.4583 16.2599 11.375 16.1766L7.82149 12.6231C7.64049 12.4421 7.55416 12.2307 7.56249 11.9891C7.57082 11.7474 7.66665 11.5349 7.84999 11.3516C8.03332 11.1682 8.24582 11.0766 8.48749 11.0766C8.72916 11.0766 8.94166 11.1682 9.12499 11.3516L11.1 13.3516V4.50156C11.1 4.24656 11.1857 4.03281 11.3572 3.86031C11.5287 3.68781 11.7412 3.60156 11.9947 3.60156C12.2482 3.60156 12.4625 3.68781 12.6375 3.86031C12.8125 4.03281 12.9 4.24656 12.9 4.50156V13.3516L14.9 11.3516C15.0833 11.1682 15.2958 11.0807 15.5375 11.0891C15.7792 11.0974 15.9917 11.1932 16.175 11.3766C16.3583 11.5599 16.45 11.7724 16.45 12.0141C16.45 12.2557 16.3595 12.4665 16.1785 12.6463L12.625 16.1766C12.535 16.2599 12.4375 16.3224 12.3325 16.3641C12.2275 16.4057 12.115 16.4266 11.995 16.4266Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRed);
export default __webpack_public_path__ + "static/media/bottom_red.dc79f815e67355e44ca5d811bca17297.svg";
export { ForwardRef as ReactComponent };